import { render, staticRenderFns } from "./Standalone.vue?vue&type=template&id=5b853f2c&"
import script from "./Standalone.vue?vue&type=script&lang=js&"
export * from "./Standalone.vue?vue&type=script&lang=js&"
import style0 from "./Standalone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports